export function filterByPropertyValue<T extends Record<string, any>, K>(
  array: T[],
  property: keyof T,
  toRemove:T[keyof T][]): T[] {
  return array
    .filter(e => !toRemove.includes(e[property]))
}

